export const readReportResult = (response) => {
  if (response?.isSuccess !== true || !response.result) {
    throw new Error(response?.message || "Could not load report");
  }
  return response.result;
};
